/* eslint-disable @typescript-eslint/no-explicit-any */

type FieldError = {
  field?: string;
  message?: string;
};

export function getErrorMessage(error?: any) {
  let message = '';

  if (!error) {
    return message;
  }

  if (typeof error === 'string') {
    return error;
  }

  if (error?.details) {
    return error?.details;
  }

  if (error?.errors?.length) {
    const nonFieldErrors = 'non_field_errors';
    Object.values(error.errors).forEach(err => {
      const error = err as FieldError;
      message += ` ${error.field && error.field !== nonFieldErrors ? `${error.field}: ` : ''} ${
        error.message
      }\n`;
    });
  } else if (error?.message) {
    message = error.message;
  } else {
    if (typeof error === 'object') {
      Object.values(error).forEach(err => {
        message += ` ${err}\n`;
      });
    }
  }

  if (typeof message === 'object') {
    return '';
  }

  if (message?.startsWith('Unexpected JSON')) {
    return 'Server error.';
  }

  return message;
}
